<template>
  <div class="error">
    视阅
  </div>
</template>

<script>
export default {
  data () {
    return {}
  }
}
</script>

<style lang="stylus" scoped>
.error
  height 100%
  overflow hidden
</style>
